import {createClient} from "@connectrpc/connect";
import {apiTransport} from "../api/connectTransport";
import {ActivationService} from "../gen/kitecorp/transferify/account/v1/activation_pb";

/** The profile snapshot returned by the authenticated activation call. */
export interface ActivationProfile {
	fullName: string;
	email: string;
	company: string | null;
}

/** Activates the signed-in account using the token retained in the route. */
export async function activateAccount(token: string): Promise<ActivationProfile> {
	const {fullName, email, company} = await createClient(ActivationService, apiTransport).activateAccount({linkToken: token});
	return {fullName, email, company: company ?? null};
}

/** Requests a replacement activation email for the signed-in account. */
export async function resendConfirmationEmail(): Promise<void> {
	await createClient(ActivationService, apiTransport).resendActivationEmail({});
}
